import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import type { IkeFetchable } from '@ikegps/core-shared';
import { Services } from '../services';

export class CollectionSummaryStore {
	get(revision: string): CollectionSummaryJSONObject | null {
		const rest = Services.Department.rest;
		return rest.CollectionSummary.getByRevision(revision).value;
	}

	getLatest(revision: string): CollectionSummaryJSONObject | null {
		const rest = Services.Department.rest;
		const summary = rest.CollectionSummary.getByRevision(revision).value;
		if (summary == null) {
			return null;
		}

		const latestSummary = rest.CollectionSummary.getByUuid(summary.uuid).value;
		if (latestSummary == null) {
			return null;
		}

		return latestSummary;
	}

	fetch(revision: string): Promise<CollectionSummaryJSONObject> {
		const rest = Services.Department.rest;
		return rest.CollectionSummary.getByRevision(revision).fetch();
	}

	fetchByUuid(uuid: string): Promise<CollectionSummaryJSONObject> {
		const rest = Services.Department.rest;
		return rest.CollectionSummary.getByUuid(uuid).fetch();
	}

	getFetchableByUuid(uuid: string): IkeFetchable<CollectionSummaryJSONObject> {
		const rest = Services.Department.rest;
		return rest.CollectionSummary.getByUuid(uuid);
	}
}
